import { Controller } from '@hotwired/stimulus'

// Cycles a set of answer panels with prev/next buttons plus either a student
// select (review pages) or a "Response X of N" counter (present-mode slides).
//
// persistKey (optional) remembers the shown answer's id so the position
// survives the Turbo re-renders present mode streams in — keyed the same way
// the retired response-carousel was, so existing localStorage state carries
// over. Panels opt in by carrying data-id.
export default class extends Controller {
  static targets = ['select', 'answer', 'counter']
  static values = { persistKey: String }

  connect() {
    // Start from whichever panel the (possibly Turbo-cached) DOM already
    // shows — the hidden classes survive a cache restore, so a reconnect
    // must not bounce the teacher back to the first answer.
    let index = Math.max(0, this.answerTargets.findIndex(panel => !panel.classList.contains('hidden')))
    if (this.hasPersistKeyValue) {
      const savedId = localStorage.getItem(this.persistKeyValue)
      const saved = this.answerTargets.findIndex(panel => panel.dataset.id === savedId)
      if (saved >= 0) index = saved
    }
    this.show(index)
  }

  change() {
    this.show(Number(this.selectTarget.value))
  }

  previous() {
    this.step(-1)
  }

  next() {
    this.step(1)
  }

  step(delta) {
    const count = this.answerTargets.length
    if (count === 0) return

    this.show((this.index + delta + count) % count)
  }

  show(index) {
    this.index = index
    this.answerTargets.forEach((panel, i) => panel.classList.toggle('hidden', i !== index))
    if (this.hasSelectTarget) this.selectTarget.value = String(index)
    if (this.hasCounterTarget) this.counterTarget.textContent = String(index + 1)
    if (this.hasPersistKeyValue) {
      const id = this.answerTargets[index]?.dataset.id
      if (id) localStorage.setItem(this.persistKeyValue, id)
    }
  }
}
